import { Checkbox, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { ArrowUpward, Folder } from '@material-ui/icons';
import React, { useCallback } from 'react';
import { useSelection, useTreePicker } from "../../hooks/index.js";
/**
 * Represents a list picker component.
 */
export function TreePicker(props) {
  const {
    selection,
    setSelection
  } = useSelection();
  const {
    items,
    navigateTo,
    isLoading,
    error
  } = useTreePicker({
    repository: props.repository,
    currentPath: props.currentPath,
    navigationPath: props.navigationPath,
    selectionRoots: props.selectionRoots,
    allowMultiple: props.allowMultiple,
    itemsODataOptions: props.itemsODataOptions,
    parentODataOptions: props.parentODataOptions
  });
  const onCheckedChangeHandler = useCallback((_event, node) => {
    if (!node.isParent) {
      const newSelection = props.allowMultiple ? selection.filter(item => item.Id !== node.Id) : [];
      if (newSelection.length === selection.length || !props.allowMultiple && selection[0].Id !== node.Id) {
        newSelection.push(node);
      }
      setSelection(newSelection);
    }
  }, [props, selection, setSelection]);
  const onDoubleClickHandler = useCallback((_event, node) => {
    if (node.IsFolder || node.isParent) {
      var _props$onTreeNavigati;
      navigateTo(node);
      if (props.setNavigationPath) {
        props.setNavigationPath(node.Path);
      }
      (_props$onTreeNavigati = props.onTreeNavigation) === null || _props$onTreeNavigati === void 0 ? void 0 : _props$onTreeNavigati.call(props, node.Path);
    }
  }, [navigateTo, props]);
  const defaultRenderer = useCallback(item => {
    var _props$selectionRoots, _props$selectionBlack, _props$renderIcon;
    if (item.isParent && (_props$selectionRoots = props.selectionRoots) !== null && _props$selectionRoots !== void 0 && _props$selectionRoots.includes(item.Path)) {
      return /*#__PURE__*/React.createElement(ListItem, {
        "data-test": "picker-up",
        key: item.Id,
        button: true
      }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(ArrowUpward, null)), /*#__PURE__*/React.createElement(ListItemText, {
        primary: '[..]'
      }));
    }
    const labelId = `checkbox-list-label-${item.Id}`;
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.Id,
      button: true
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, !((_props$selectionBlack = props.selectionBlacklist) !== null && _props$selectionBlack !== void 0 && _props$selectionBlack.includes(item.Path)) && /*#__PURE__*/React.createElement(Checkbox, {
      "data-test": `picker-checkbox-item-${item.Name.replace(/\s+/g, '-').toLowerCase()}`,
      color: "primary",
      edge: "start",
      checked: selection.some(selected => selected.Id === item.Id),
      onChange: e => onCheckedChangeHandler(e, item),
      onDoubleClick: e => e.stopPropagation(),
      tabIndex: -1,
      disableRipple: true,
      inputProps: {
        'aria-labelledby': labelId
      }
    })), /*#__PURE__*/React.createElement(ListItemIcon, null, ((_props$renderIcon = props.renderIcon) === null || _props$renderIcon === void 0 ? void 0 : _props$renderIcon.call(props, item)) || /*#__PURE__*/React.createElement(Folder, {
      style: {
        color: 'primary'
      }
    })), /*#__PURE__*/React.createElement(ListItemText, {
      id: labelId,
      primary: item.DisplayName,
      secondary: item.Path.replace(new RegExp('^/Root', 'g'), '')
    }));
  }, [selection, onCheckedChangeHandler, props]);
  const renderItem = props.renderItem || defaultRenderer;
  if (isLoading) {
    var _props$renderLoading;
    return ((_props$renderLoading = props.renderLoading) === null || _props$renderLoading === void 0 ? void 0 : _props$renderLoading.call(props)) || null;
  }
  if (error) {
    var _props$renderError;
    return ((_props$renderError = props.renderError) === null || _props$renderError === void 0 ? void 0 : _props$renderError.call(props, error.message)) || /*#__PURE__*/React.createElement(Typography, {
      color: "error",
      variant: "caption"
    }, error.message);
  }
  return /*#__PURE__*/React.createElement(List, null, items === null || items === void 0 ? void 0 : items.map(item => /*#__PURE__*/React.createElement("div", {
    onClick: e => onCheckedChangeHandler(e, item),
    onDoubleClick: e => onDoubleClickHandler(e, item),
    key: item.Id
  }, renderItem(item))));
}
//# sourceMappingURL=tree-picker.js.map